<template>
    <b-container>
        <b-row row wrap>
            <b-col cols="12">
                <app-sub-title text="Lista de chequeo"></app-sub-title>
                <small class="text-muted">Pueden ser configurados después</small>
            </b-col>
        </b-row>
        <b-row align-v="center">
            <b-col cols="12" md="10">
                <app-form-text-input
                    placeholder="Item"
                    v-model="item.name"
                    ref="checklistName"
                    id="checklist-name"
                ></app-form-text-input>
            </b-col>
            <b-col cols="12" md="2">
                <b-btn variant="primary" size="sm" @click="addItem"><i class="fa fa-plus"></i></b-btn>
            </b-col>
        </b-row>
        <div class="items">
            <b-row v-for="(itm, index) in items" :key="index" align-v="center">
                <b-col cols="1">{{ index + 1 }}</b-col>
                <b-col cols="7">{{ itm.name }}</b-col>
                <b-col cols="3"><b-btn variant="danger" size="sm" @click="removeItem(index)"><i class="fa fa-trash"></i></b-btn></b-col>
            </b-row>
        </div>
    </b-container>
</template>
<script>
export default {
    data: () => ({
        item: {
            name: ''
        },
        items: []
    }),
    methods: {
        reset() {
            this.item.name = '';
            this.items = [];
        },
        addItem() {
            if(!this.item.name) return;

            if(!this.items.map(item => item.name.toLowerCase()).includes(this.item.name.toLowerCase())){
                this.items.push({...this.item});
                this.item.name = '';
                this.$refs.checklistName.focus();
                this.update();
            }
        },
        removeItem(index) {
            this.items.splice(index, 1);
            this.update();
        },
        update() {
            this.$emit('input', this.items);
            this.$emit('change', this.items);
        }
    }
}
</script>
